import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gstar-unsave-change-warning',
  templateUrl: './unsave-change-warning.component.html',
  styleUrl: './unsave-change-warning.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnsaveChangeWarningComponent {
  @Input() modalId: string = '';
  @Input() disabledSaveButton: boolean = false;
}
